import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { MONTH_ITEM_HEIGHT as ce } from "../config.js";
import { datePickerInjectionKey as Ta } from "../interface.js";
import { dateArray as ve, yearArray as me, pluckValueFromRange as I, quarterArray as ye, monthArray as he, getDefaultTime as K, strictParse as U } from "../utils.js";
import { usePanelCommonProps as Ma, usePanelCommon as Oa } from "./use-panel-common.js";
import { inject as Ea, computed as i, watch as J } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as c } from "../../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { getTime as l } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/getTime.js";
import { addMonths as m } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/addMonths.js";
import { formatDate as A } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/format.js";
import { startOfMonth as Y } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/startOfMonth.js";
import { getYear as v } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/getYear.js";
import { getMonth as f } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/getMonth.js";
import { set as y } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/set.js";
import { isValid as q } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/isValid.js";
import { getDate as T } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/getDate.js";
import { startOfQuarter as De } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/startOfQuarter.js";
import { startOfSecond as Ya } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/startOfSecond.js";
import { startOfDay as Pa } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/startOfDay.js";
const $a = Object.assign(Object.assign({}, Ma), {
  defaultCalendarStartTime: Number,
  defaultCalendarEndTime: Number,
  bindCalendarMonths: Boolean,
  actions: {
    type: Array,
    default: () => ["clear", "confirm"]
  }
});
function pa(n, R) {
  var z, B;
  const {
    isDateDisabledRef: X,
    isStartHourDisabledRef: Ae,
    isEndHourDisabledRef: Re,
    isStartMinuteDisabledRef: Ce,
    isEndMinuteDisabledRef: ge,
    isStartSecondDisabledRef: Se,
    isEndSecondDisabledRef: Ve,
    isStartDateInvalidRef: be,
    isEndDateInvalidRef: Fe,
    isStartTimeInvalidRef: we,
    isEndTimeInvalidRef: Te,
    isStartValueInvalidRef: Me,
    isEndValueInvalidRef: Oe,
    isRangeInvalidRef: Z,
    localeRef: S,
    rangesRef: $,
    closeOnSelectRef: Ee,
    updateValueOnCloseRef: Ye,
    firstDayOfWeekRef: p,
    datePickerSlots: Pe,
    monthFormatRef: ee,
    yearFormatRef: ae,
    quarterFormatRef: te,
    yearRangeRef: j
  } = Ea(Ta), Ie = {
    isDateDisabled: X,
    isStartHourDisabled: Ae,
    isEndHourDisabled: Re,
    isStartMinuteDisabled: Ce,
    isEndMinuteDisabled: ge,
    isStartSecondDisabled: Se,
    isEndSecondDisabled: Ve,
    isStartDateInvalid: be,
    isEndDateInvalid: Fe,
    isStartTimeInvalid: we,
    isEndTimeInvalid: Te,
    isStartValueInvalid: Me,
    isEndValueInvalid: Oe,
    isRangeInvalid: Z
  }, r = Oa(n), ke = c(null), xe = c(null), ne = c(null), re = c(null), k = c(null), x = c(null), N = c(null), Q = c(null), {
    value: C
  } = n, le = (z = n.defaultCalendarStartTime) !== null && z !== void 0 ? z : Array.isArray(C) && typeof C[0] == "number" ? C[0] : Date.now(), s = c(le), o = c((B = n.defaultCalendarEndTime) !== null && B !== void 0 ? B : Array.isArray(C) && typeof C[1] == "number" ? C[1] : l(m(le, 1)));
  h(!0);
  const V = c(Date.now()), b = c(!1), P = c(0), g = i(() => n.dateFormat || S.value.dateFormat), _e = i(() => n.calendarDayFormat || S.value.dayFormat), M = c(Array.isArray(C) ? A(C[0], g.value, r.dateFnsOptions.value) : ""), O = c(Array.isArray(C) ? A(C[1], g.value, r.dateFnsOptions.value) : ""), He = i(() => b.value ? "end" : "start"), ue = i(() => {
    var e;
    return ve(s.value, n.value, V.value, (e = p.value) !== null && e !== void 0 ? e : S.value.firstDayOfWeek);
  }), je = i(() => {
    var e;
    return ve(o.value, n.value, V.value, (e = p.value) !== null && e !== void 0 ? e : S.value.firstDayOfWeek);
  }), Ue = i(() => ue.value.slice(0, 7).map((e) => {
    const {
      ts: a
    } = e;
    return A(a, _e.value, r.dateFnsOptions.value);
  })), qe = i(() => A(s.value, n.calendarHeaderMonthFormat || S.value.monthFormat, r.dateFnsOptions.value)), ze = i(() => A(o.value, n.calendarHeaderMonthFormat || S.value.monthFormat, r.dateFnsOptions.value)), Be = i(() => A(s.value, n.calendarHeaderYearFormat || S.value.yearFormat, r.dateFnsOptions.value)), Ne = i(() => A(o.value, n.calendarHeaderYearFormat || S.value.yearFormat, r.dateFnsOptions.value)), Qe = i(() => {
    const {
      value: e
    } = n;
    return Array.isArray(e) ? e[0] : null;
  }), We = i(() => {
    const {
      value: e
    } = n;
    return Array.isArray(e) ? e[1] : null;
  }), Le = i(() => {
    const {
      shortcuts: e
    } = n;
    return e || $.value;
  }), Ge = i(() => me(I(n.value, "start"), V.value, {
    yearFormat: ae.value
  }, j)), Ke = i(() => me(I(n.value, "end"), V.value, {
    yearFormat: ae.value
  }, j)), Je = i(() => {
    const e = I(n.value, "start");
    return ye(e != null ? e : Date.now(), e, V.value, {
      quarterFormat: te.value
    });
  }), Xe = i(() => {
    const e = I(n.value, "end");
    return ye(e != null ? e : Date.now(), e, V.value, {
      quarterFormat: te.value
    });
  }), Ze = i(() => {
    const e = I(n.value, "start");
    return he(e != null ? e : Date.now(), e, V.value, {
      monthFormat: ee.value
    });
  }), $e = i(() => {
    const e = I(n.value, "end");
    return he(e != null ? e : Date.now(), e, V.value, {
      monthFormat: ee.value
    });
  }), pe = i(() => {
    var e;
    return (e = n.calendarHeaderMonthBeforeYear) !== null && e !== void 0 ? e : S.value.monthBeforeYear;
  });
  J(i(() => n.value), (e) => {
    if (e !== null && Array.isArray(e)) {
      const [a, t] = e;
      M.value = A(a, g.value, r.dateFnsOptions.value), O.value = A(t, g.value, r.dateFnsOptions.value), b.value || da(e);
    } else
      M.value = "", O.value = "";
  });
  function ie(e, a) {
    (R === "daterange" || R === "datetimerange") && (v(e) !== v(a) || f(e) !== f(a)) && r.disableTransitionOneTick();
  }
  J(s, ie), J(o, ie);
  function h(e) {
    const a = Y(s.value), t = Y(o.value);
    (n.bindCalendarMonths || a >= t) && (e ? o.value = l(m(a, 1)) : s.value = l(m(t, -1)));
  }
  function ea() {
    s.value = l(m(s.value, 12)), h(!0);
  }
  function aa() {
    s.value = l(m(s.value, -12)), h(!0);
  }
  function ta() {
    s.value = l(m(s.value, 1)), h(!0);
  }
  function na() {
    s.value = l(m(s.value, -1)), h(!0);
  }
  function ra() {
    o.value = l(m(o.value, 12)), h(!1);
  }
  function la() {
    o.value = l(m(o.value, -12)), h(!1);
  }
  function ua() {
    o.value = l(m(o.value, 1)), h(!1);
  }
  function ia() {
    o.value = l(m(o.value, -1)), h(!1);
  }
  function oa(e) {
    s.value = e, h(!0);
  }
  function sa(e) {
    o.value = e, h(!1);
  }
  function oe(e) {
    const a = X.value;
    if (!a)
      return !1;
    if (!Array.isArray(n.value) || He.value === "start")
      return a(e, "start", null);
    {
      const {
        value: t
      } = P;
      return e < P.value ? a(e, "start", [t, t]) : a(e, "end", [t, t]);
    }
  }
  function da(e) {
    if (e === null)
      return;
    const [a, t] = e;
    s.value = a, Y(t) <= Y(a) ? o.value = l(Y(m(a, 1))) : o.value = l(Y(t));
  }
  function fa(e) {
    if (!b.value)
      b.value = !0, P.value = e.ts, E(e.ts, e.ts, "done");
    else {
      b.value = !1;
      const {
        value: a
      } = n;
      n.panel && Array.isArray(a) ? E(a[0], a[1], "done") : Ee.value && R === "daterange" && (Ye.value ? se() : W());
    }
  }
  function ca(e) {
    if (b.value) {
      if (oe(e.ts))
        return;
      e.ts >= P.value ? E(P.value, e.ts, "wipPreview") : E(e.ts, P.value, "wipPreview");
    }
  }
  function W() {
    Z.value || (r.doConfirm(), se());
  }
  function se() {
    b.value = !1, n.active && r.doClose();
  }
  function _(e) {
    typeof e != "number" && (e = l(e)), n.value === null ? r.doUpdateValue([e, e], n.panel) : Array.isArray(n.value) && r.doUpdateValue([e, Math.max(n.value[1], e)], n.panel);
  }
  function H(e) {
    typeof e != "number" && (e = l(e)), n.value === null ? r.doUpdateValue([e, e], n.panel) : Array.isArray(n.value) && r.doUpdateValue([Math.min(n.value[0], e), e], n.panel);
  }
  function E(e, a, t) {
    if (typeof e != "number" && (e = l(e)), t !== "shortcutPreview" && t !== "shortcutDone") {
      let d, w;
      if (R === "datetimerange") {
        const {
          defaultTime: u
        } = n;
        Array.isArray(u) ? (d = K(u[0]), w = K(u[1])) : (d = K(u), w = d);
      }
      d && (e = l(y(e, d))), w && (a = l(y(a, w)));
    }
    r.doUpdateValue([e, a], n.panel && (t === "done" || t === "shortcutDone"));
  }
  function D(e) {
    return R === "datetimerange" ? l(Ya(e)) : R === "monthrange" ? l(Y(e)) : l(Pa(e));
  }
  function va(e) {
    const a = U(e, g.value, /* @__PURE__ */ new Date(), r.dateFnsOptions.value);
    if (q(a))
      if (n.value) {
        if (Array.isArray(n.value)) {
          const t = y(n.value[0], {
            year: v(a),
            month: f(a),
            date: T(a)
          });
          _(D(l(t)));
        }
      } else {
        const t = y(/* @__PURE__ */ new Date(), {
          year: v(a),
          month: f(a),
          date: T(a)
        });
        _(D(l(t)));
      }
    else
      M.value = e;
  }
  function ma(e) {
    const a = U(e, g.value, /* @__PURE__ */ new Date(), r.dateFnsOptions.value);
    if (q(a)) {
      if (n.value === null) {
        const t = y(/* @__PURE__ */ new Date(), {
          year: v(a),
          month: f(a),
          date: T(a)
        });
        H(D(l(t)));
      } else if (Array.isArray(n.value)) {
        const t = y(n.value[1], {
          year: v(a),
          month: f(a),
          date: T(a)
        });
        H(D(l(t)));
      }
    } else
      O.value = e;
  }
  function ya() {
    const e = U(M.value, g.value, /* @__PURE__ */ new Date(), r.dateFnsOptions.value), {
      value: a
    } = n;
    if (q(e)) {
      if (a === null) {
        const t = y(/* @__PURE__ */ new Date(), {
          year: v(e),
          month: f(e),
          date: T(e)
        });
        _(D(l(t)));
      } else if (Array.isArray(a)) {
        const t = y(a[0], {
          year: v(e),
          month: f(e),
          date: T(e)
        });
        _(D(l(t)));
      }
    } else
      de();
  }
  function ha() {
    const e = U(O.value, g.value, /* @__PURE__ */ new Date(), r.dateFnsOptions.value), {
      value: a
    } = n;
    if (q(e)) {
      if (a === null) {
        const t = y(/* @__PURE__ */ new Date(), {
          year: v(e),
          month: f(e),
          date: T(e)
        });
        H(D(l(t)));
      } else if (Array.isArray(a)) {
        const t = y(a[1], {
          year: v(e),
          month: f(e),
          date: T(e)
        });
        H(D(l(t)));
      }
    } else
      de();
  }
  function de(e) {
    const {
      value: a
    } = n;
    if (a === null || !Array.isArray(a)) {
      M.value = "", O.value = "";
      return;
    }
    e === void 0 && (e = a), M.value = A(e[0], g.value, r.dateFnsOptions.value), O.value = A(e[1], g.value, r.dateFnsOptions.value);
  }
  function Da(e) {
    e !== null && _(e);
  }
  function Aa(e) {
    e !== null && H(e);
  }
  function Ra(e) {
    r.cachePendingValue();
    const a = r.getShortcutValue(e);
    Array.isArray(a) && E(a[0], a[1], "shortcutPreview");
  }
  function Ca(e) {
    const a = r.getShortcutValue(e);
    Array.isArray(a) && (E(a[0], a[1], "shortcutDone"), r.clearPendingValue(), W());
  }
  function F(e, a) {
    const t = e === void 0 ? n.value : e;
    if (e === void 0 || a === "start") {
      if (N.value) {
        const d = Array.isArray(t) ? f(t[0]) : f(Date.now());
        N.value.scrollTo({
          debounce: !1,
          index: d,
          elSize: ce
        });
      }
      if (k.value) {
        const d = (Array.isArray(t) ? v(t[0]) : v(Date.now())) - j.value[0];
        k.value.scrollTo({
          index: d,
          debounce: !1
        });
      }
    }
    if (e === void 0 || a === "end") {
      if (Q.value) {
        const d = Array.isArray(t) ? f(t[1]) : f(Date.now());
        Q.value.scrollTo({
          debounce: !1,
          index: d,
          elSize: ce
        });
      }
      if (x.value) {
        const d = (Array.isArray(t) ? v(t[1]) : v(Date.now())) - j.value[0];
        x.value.scrollTo({
          index: d,
          debounce: !1
        });
      }
    }
  }
  function ga(e, a) {
    const {
      value: t
    } = n, d = !Array.isArray(t), w = e.type === "year" && R !== "yearrange" ? d ? y(e.ts, {
      month: f(R === "quarterrange" ? De(/* @__PURE__ */ new Date()) : /* @__PURE__ */ new Date())
    }).valueOf() : y(e.ts, {
      month: f(R === "quarterrange" ? De(t[a === "start" ? 0 : 1]) : t[a === "start" ? 0 : 1])
    }).valueOf() : e.ts;
    if (d) {
      const fe = D(w), G = [fe, fe];
      r.doUpdateValue(G, n.panel), F(G, "start"), F(G, "end"), r.disableTransitionOneTick();
      return;
    }
    const u = [t[0], t[1]];
    let L = !1;
    switch (a === "start" ? (u[0] = D(w), u[0] > u[1] && (u[1] = u[0], L = !0)) : (u[1] = D(w), u[0] > u[1] && (u[0] = u[1], L = !0)), r.doUpdateValue(u, n.panel), R) {
      case "monthrange":
      case "quarterrange":
        r.disableTransitionOneTick(), L ? (F(u, "start"), F(u, "end")) : F(u, a);
        break;
      case "yearrange":
        r.disableTransitionOneTick(), F(u, "start"), F(u, "end");
    }
  }
  function Sa() {
    var e;
    (e = ne.value) === null || e === void 0 || e.sync();
  }
  function Va() {
    var e;
    (e = re.value) === null || e === void 0 || e.sync();
  }
  function ba(e) {
    var a, t;
    return e === "start" ? ((a = k.value) === null || a === void 0 ? void 0 : a.listElRef) || null : ((t = x.value) === null || t === void 0 ? void 0 : t.listElRef) || null;
  }
  function Fa(e) {
    var a, t;
    return e === "start" ? ((a = k.value) === null || a === void 0 ? void 0 : a.itemsElRef) || null : ((t = x.value) === null || t === void 0 ? void 0 : t.itemsElRef) || null;
  }
  const wa = {
    startYearVlRef: k,
    endYearVlRef: x,
    startMonthScrollbarRef: N,
    endMonthScrollbarRef: Q,
    startYearScrollbarRef: ne,
    endYearScrollbarRef: re
  };
  return Object.assign(Object.assign(Object.assign(Object.assign({
    startDatesElRef: ke,
    endDatesElRef: xe,
    handleDateClick: fa,
    handleColItemClick: ga,
    handleDateMouseEnter: ca,
    handleConfirmClick: W,
    startCalendarPrevYear: aa,
    startCalendarPrevMonth: na,
    startCalendarNextYear: ea,
    startCalendarNextMonth: ta,
    endCalendarPrevYear: la,
    endCalendarPrevMonth: ia,
    endCalendarNextMonth: ua,
    endCalendarNextYear: ra,
    mergedIsDateDisabled: oe,
    changeStartEndTime: E,
    ranges: $,
    calendarMonthBeforeYear: pe,
    startCalendarMonth: qe,
    startCalendarYear: Be,
    endCalendarMonth: ze,
    endCalendarYear: Ne,
    weekdays: Ue,
    startDateArray: ue,
    endDateArray: je,
    startYearArray: Ge,
    startMonthArray: Ze,
    startQuarterArray: Je,
    endYearArray: Ke,
    endMonthArray: $e,
    endQuarterArray: Xe,
    isSelecting: b,
    handleRangeShortcutMouseenter: Ra,
    handleRangeShortcutClick: Ca
  }, r), Ie), wa), {
    // datetimerangeonly
    startDateDisplayString: M,
    endDateInput: O,
    timePickerSize: r.timePickerSize,
    startTimeValue: Qe,
    endTimeValue: We,
    datePickerSlots: Pe,
    shortcuts: Le,
    startCalendarDateTime: s,
    endCalendarDateTime: o,
    justifyColumnsScrollState: F,
    handleFocusDetectorFocus: r.handleFocusDetectorFocus,
    handleStartTimePickerChange: Da,
    handleEndTimePickerChange: Aa,
    handleStartDateInput: va,
    handleStartDateInputBlur: ya,
    handleEndDateInput: ma,
    handleEndDateInputBlur: ha,
    handleStartYearVlScroll: Sa,
    handleEndYearVlScroll: Va,
    virtualListContainer: ba,
    virtualListContent: Fa,
    onUpdateStartCalendarValue: oa,
    onUpdateEndCalendarValue: sa
  });
}
export {
  pa as useDualCalendar,
  $a as useDualCalendarProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/date-picker/src/panel/use-dual-calendar.js
// module id = 461
// module chunks = 41